import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {NotificationService} from '../../../core/services';
import {AdminApi} from '../../../api/endpoints';
import {AdminUserModel} from '../../../api/model/Admin-user.model';

@Injectable({
  providedIn: 'root'
})
export class AdminsService {
  private readonly adminApi = inject(AdminApi);
  private readonly notificationService = inject(NotificationService);

  constructor() {
  }

  createAdmin(admin: Partial<AdminUserModel>): Observable<AdminUserModel> {
    return this.adminApi.createAdmin(admin).pipe(
      tap(() => {
        this.notificationService.success('Admin created successfully');
      }),
      catchError(error => {
        this.notificationService.error(`Failed to create admin: ${error}`);
        throw error;
      })
    );
  }

  updateAdmin(id: string | number, admin: Partial<AdminUserModel>): Observable<AdminUserModel> {
    admin.id = id;
    return this.adminApi.updateAdmin(id, admin).pipe(
      tap(() => {
        this.notificationService.success('Admin updated successfully');
      }),
      catchError(error => {
        this.notificationService.error(`Failed to update admin: ${error}`);
        throw error;
      })
    );
  }

  deleteAdmin(id: string | number): Observable<void> {
    return this.adminApi.deleteAdmin(id).pipe(
      tap(() => {
        this.notificationService.success('Admin deleted successfully');
      }),
      catchError(error => {
        this.notificationService.error(`Failed to delete admin: ${error}`);
        throw error;
      })
    );
  }
}
